import { render, staticRenderFns } from "./ListAlbumsRow.vue?vue&type=template&id=5041b327&scoped=true&"
import script from "./ListAlbumsRow.vue?vue&type=script&lang=js&"
export * from "./ListAlbumsRow.vue?vue&type=script&lang=js&"
import style0 from "./ListAlbumsRow.vue?vue&type=style&index=0&id=5041b327&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5041b327",
  null
  
)

export default component.exports